import axios from 'axios';
import config from '../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../core/modules/common/tools/URLTools';

const apiFetchHandoverAnalysisAtDestination = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getHandoverAnalysisAtDestination',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchHandoverAnalysisAtDestination;
